<template>
    <div class="test4-box">
        test4
    </div>
</template>

<script>
    export default {
        name:'test4',
        data(){
            return {

            }
        },
        methods:{

        },
        computed:{

        },
        mounted(){

        },
        beforeMount(){

        },
        watch:{
          // 如果 `某个属性` 发生改变，这个属性对应的函数就会运行
        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/testpage/test4.vue